export default {
      id: "basket-usage",
      viewBox: "0 0 512 410",
      url: __webpack_public_path__ + "img/svg-sprite.svg#basket",
      toString: function () {
        return this.url;
      }
    }